import { render, staticRenderFns } from "./vendas.vue?vue&type=template&id=5a65c0c3&scoped=true&"
import script from "./vendas.vue?vue&type=script&lang=js&"
export * from "./vendas.vue?vue&type=script&lang=js&"
import style0 from "./vendas.vue?vue&type=style&index=0&id=5a65c0c3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a65c0c3",
  null
  
)

export default component.exports